<div class="mui-number-badge-container" [class.isAnimating]="isAnimating()" aria-hidden="true">
  <svg version="1.1" class='notification-bubble' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
    <circle class="notification-bubble__circle bubble" cx="50%" cy="50%" [attr.r]=" _count > 99 ? 9.5 : 8"/>
    <text class="notification-bubble__text number" x="50%" y="53%" dominant-baseline="middle" text-anchor="middle"
          font-size="10" fill="white">{{ _count > 99 ? '99+' : _count }}</text>
  </svg>
</div>
